<template>
	<nuxt-link
		:id="blok._uid"
		:to="url"
		:title="tg('accessibility.open-brand', {brand: blok.title})"
	>
		<div class="relative h-min">
			<nuxt-picture
				:src="blok.icon?.filename"
				:alt="blok.icon?.alt"
				provider="storyblok"
				sizes="xs:40vw sm:296px md:208px lg:130px xl:173px 2xl:224px"
				class="w-full"
				loading="lazy"
				:width="size?.width"
				:height="size?.height"
				fit="in"
				:img-attrs="{
					// eslint-disable-next-line max-len
					class:
						'w-full h-full hover:scale-110 transition duration-500 cursor-pointer object-cover',
					fetchpriority: (componentIndex ?? 5) <= 4 ? 'high' : 'low',
				}"
			/>

			<!-- <div v-if="blok.title"
                class="absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2
                bg-white/70 py-xs text-center text-2xl font-bold">
                {{ blok.title }}
            </div> -->
		</div>
	</nuxt-link>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

import formatSbUrl from "@pkg/shared/utils/format-sb-url";
import sbImageDimensions from "@pkg/shared/utils/sb-image-dimensions";

const properties = defineProps<{
	blok: Extract<
		BlokComponent,
		{component: "sb-brands-grid" | "sb-brands-grid-brand"}
	>;
	componentIndex?: number;
}>();

const {t: tg} = useI18n({useScope: "global"});
const url = computed(() => formatSbUrl(properties.blok.link));

const size = computed(() =>
	properties.blok.icon?.filename
		? sbImageDimensions(properties.blok.icon.filename)
		: undefined,
);
</script>
